module.exports = "/images/get-more-foot-traffic.svg?763179275a75f942a504f7f60bbb17f9";